import React, { useRef } from 'react';

import PageSideBarNavigation from '../../../../../PageSideBarNavigation';

export default function TeamSide() {
  const links = useRef([
    { to: '/team/strategy', text: 'Set strategy' },
    { to: '/team/squad', text: 'View squad' },
    { to: '/team/development', text: 'Team development' },
  ]);

  return (
    <>
      <PageSideBarNavigation links={links.current} />
    </>
  );
}
